import { render } from "./Demonstrate.vue?vue&type=template&id=84d56c6e&scoped=true"
import script from "./Demonstrate.vue?vue&type=script&lang=js"
export * from "./Demonstrate.vue?vue&type=script&lang=js"

import "./Demonstrate.vue?vue&type=style&index=0&id=84d56c6e&scoped=true&lang=css"
import "./Demonstrate.vue?vue&type=style&index=1&id=84d56c6e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d56c6e"]])

export default __exports__